import React from "react";
import { NavBar } from "../Components/NavBar";
import { Footer } from "../Components/Footer";
import { motion } from "framer-motion";
import { ShieldCheck, Zap, Check, Globe, Clock } from "lucide-react";
import businessImg from "../Assets/Images/remesalogo.png";
import empresarioImg from "../Assets/Images/manc.jpg";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

function Empresas() {

    const casos = [
        {
            title: "Estables",
            desc: "USDT / USDC ayudan a mitigar la volatilidad y acelerar la liquidación en ciertos corredores.",
            icon: <Zap />,
            color: "#2a9d8f",
        },
        {
            title: "Cumpliendo reforzado",
            desc: "Procesos KYB / KYC, monitoreo transaccional y listas de sanciones, con reportes para auditoría.",
            icon: <ShieldCheck />,
            color: "#f4a261",
        },
        {
            title: "Pagos internacionales simplificados",
            desc: "Centraliza pagos a proveedores y talento internacional, con liquidez multi-moneda y conciliación automática.",
            icon: <Globe />,
            color: "#e76f51",
        },
        {
            title: "Automatización de nómina",
            desc: "Genera pagos recurrentes de nómina automáticamente en múltiples países y monedas.",
            icon: <Clock />,
            color: "#264653",
        },
    ];

    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            q: "¿Cómo registro mi empresa?",
            a: "El registro es sencillo. Solo debes completar nuestro formulario de alta empresarial y enviarnos la documentación legal requerida (acta de constitución, identificación de representantes y beneficiarios finales, y comprobante de actividad). Una vez validada la información, tu empresa podrá empezar a operar con RemesaEspana Business.",
        },
        {
            q: "¿Puedo pagar a proveedores en distintos países con la misma cuenta?",
            a: "Sí. Desde tu perfil Business puedes centralizar todos los pagos internacionales de tu empresa. Nos envías los fondos en euros o dólares, y nosotros gestionamos la entrega a tus proveedores o empleados en bolívares, dólares o stablecoins (USDT/USDC), según tus necesidades.",
        },
        {
            q: "¿Cómo funciona el uso de USDT/USDC?",
            a: "Además de pagos en moneda local o dólares, ofrecemos la opción de liquidar en stablecoins (USDT y USDC). Esto permite transacciones más rápidas, disponibles 24/7, y ayuda a reducir los costos frente a transferencias internacionales tradicionales. Validamos billeteras y cumplimos con regulaciones para que el proceso sea seguro.",
        },
        {
            q: "¿Cuál es el tiempo de espera para los pagos?",
            a: "Una vez confirmada la recepción de los fondos en nuestra cuenta, el pago a tu proveedor o empleado se procesa en un lapso de 15 a 20 minutos, con disponibilidad al instante.",
        },
        {
            q: "¿Qué cumplimiento aplican (KYC/KYB/AML)?",
            a: "En RemesaEspana Business cumplimos con estándares internacionales de seguridad: KYC/KYB: verificación de identidad de la empresa, representantes y beneficiarios. AML: monitoreo de transacciones, listas de sanciones y análisis de origen y destino de fondos. Así aseguramos que cada operación sea confiable y dentro de la normativa vigente.",
        },
    ];
    return (
        <div className="empresas-page">
            <NavBar />

            {/* HERO */}
            <section className="empresas-hero">
                <div className="empresas-hero-content">
                    <motion.p
                        className="hero-subtitle"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        Pagos internacionales B2B + Cripto (USDT/USDC)
                    </motion.p>

                    <motion.h1
                        className="hero-title"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        Pagos a proveedores y nómina,{" "}
                        <motion.span
                            className="highlight"
                            initial={{ opacity: 1 }}
                            animate={{ opacity: [1, 0.6, 1] }}
                            transition={{ repeat: Infinity, duration: 1.8 }}
                        >
                            más rápidos
                        </motion.span>
                        , seguros y con liquidez global
                    </motion.h1>

                    <motion.p
                        className="hero-desc"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                    >
                        Centraliza pagos a tu cadena de suministro y talento internacional
                        con <strong>RemesaEspana Business</strong>. Liquida en{" "}
                        <strong>EUR / USD / BOLÍVARES</strong> o stablecoins
                        (USDT/USDC) con trazabilidad, conciliación y controles de
                        cumplimiento.
                    </motion.p>

                    <div className="empresas-hero-badges">
                        <motion.div
                            className="badge"
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            <ShieldCheck className="icon" />
                            <span>Cumplimiento KYC/KYB & AML</span>
                        </motion.div>

                        <motion.div
                            className="badge"
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            <Zap className="icon" />
                            <span>Liquidación rápida</span>
                        </motion.div>
                    </div>
                </div>

                <div className="empresas-hero-image">
                    <img src={businessImg} alt="RemesaEspana Business Logo" />
                </div>
            </section>

            {/* SERVICES */}
            {/* PAGOS & NOMINA */}
            <section className="empresas-cards">
                <motion.div className="card" whileHover={{ y: -4, boxShadow: "0 18px 40px rgba(42,157,143,0.2)" }}>
                    <div className="card-title">
                        <Zap className="card-icon" />
                        <h3>Pago a proveedores</h3>
                    </div>
                    <p>
                        Optimiza pagos de materia prima y servicios. Liquida en EUR/USD/BS o con stablecoins para reducir tiempos y fricciones transfronterizas.
                    </p>
                </motion.div>

                <div className="divider"></div>

                <motion.div className="card" whileHover={{ y: -4, boxShadow: "0 18px 40px rgba(42,157,143,0.2)" }}>
                    <div className="card-title">
                        <Check className="card-icon" />
                        <h3>Nómina Internacional</h3>
                    </div>
                    <p>
                        Paga equipos en múltiples países con conversión automática y recibos. Opciones de retiro en bancos locales o billeteras virtuales.
                    </p>
                </motion.div>
            </section>


            <section className="casos-uso">
                <div className="casos-container">
                    <div className="casos-text">
                        <motion.p
                            className="casos-subtitle"
                            initial={{ opacity: 0, y: -10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7 }}
                        >
                            Casos de uso
                        </motion.p>

                        <motion.h2
                            className="casos-title"
                            initial={{ opacity: 0, y: -20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            Proveedores de materia prima y nómina en una sola plataforma
                        </motion.h2>

                        <div className="casos-cards">
                            {casos.map((item, index) => (
                                <motion.div
                                    className="caso-card"
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.7, delay: index * 0.2 }}
                                >
                                    <div className="caso-icon" style={{ color: item.color }}>
                                        {item.icon}
                                    </div>
                                    <div className="caso-texto">
                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    <div className="casos-image">
                        <motion.img
                            src={empresarioImg}
                            alt="Empresario"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                        />
                    </div>
                </div>
            </section>

            <section className="faq-section">
                <div className="faq-container">
                    <motion.h2
                        className="faq-title"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        🧩 Preguntas frecuentes <span>(empresas)</span>
                    </motion.h2>

                    <div className="faq-list">
                        {faqs.map((item, i) => (
                            <motion.div
                                key={i}
                                className={`faq-item ${openIndex === i ? "open" : ""}`}
                                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: i * 0.1 }}
                            >
                                <div className="faq-question">
                                    <span>{item.q}</span>
                                    <ChevronDown
                                        className={`chevron ${openIndex === i ? "rotated" : ""}`}
                                        size={20}
                                    />
                                </div>
                                {openIndex === i && (
                                    <motion.p
                                        className="faq-answer"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        {item.a}
                                    </motion.p>
                                )}
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>


            <section className="contacto-empresas">
                <div className="contacto-container">
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        Hablemos de tu negocio
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        Nuestro equipo está listo para ayudarte a optimizar pagos y nóminas internacionales.
                    </motion.p>





                    <div className="contacto-buttons">
                        <motion.a
                            href="mailto:remesaespana@hotmail.com"
                            className="btn-contacto email"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Escríbenos un email
                        </motion.a>

                        <motion.a
                            href="https://api.whatsapp.com/send/?phone=%2B34722850962&text&type=phone_number&app_absent=0"
                            className="btn-contacto whatsapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Contactanos por WhatsApp
                        </motion.a>
                    </div>
                </div>
            </section>


            <Footer />
        </div>
    );
}

export { Empresas };
